import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    py: 1.5,
    px: 2,
  },
  step: { display: 'flex', alignItems: 'center', flexDirection: 'column' },
  circleBase: (theme) => ({
    width: 28,
    height: 28,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 600,
    flexShrink: 0,
  }),
  circleActive: { bgcolor: 'primary.main', color: 'primary.contrastText' },
  circleCompleted: {
    bgcolor: 'secondary.main',
    color: 'secondary.contrastText',
  },
  circleInactive: {
    bgcolor: 'background.paper',
    color: 'text.disabled',
    border: '1.5px solid',
    borderColor: 'divider',
  },
  label: (theme) => ({
    mt: 0.5,
    fontSize: theme.typography.pxToRem(11),
    whiteSpace: 'nowrap',
  }),
};

const Stepper = ({ steps, activeStep }) => (
  <Box sx={styles.root}>
    {steps.map((step, index) => {
      const completed = activeStep > index;
      const active = activeStep === index;
      const circleState = active
        ? styles.circleActive
        : completed
          ? styles.circleCompleted
          : styles.circleInactive;
      return (
        <React.Fragment key={index}>
          {index > 0 && (
            <Box
              sx={{
                width: { xs: 48, sm: 72 },
                height: '1px',
                bgcolor: completed ? 'secondary.main' : 'divider',
                mb: '20px',
              }}
            />
          )}
          <Box sx={styles.step}>
            <Box sx={[styles.circleBase, circleState]}>
              {completed ? <CheckIcon sx={{ fontSize: 15 }} /> : index + 1}
            </Box>
            <Typography
              sx={[
                styles.label,
                {
                  fontWeight: active ? 'bold' : 'regular',
                  color: active
                    ? 'primary.main'
                    : completed
                      ? 'secondary.main'
                      : 'text.disabled',
                },
              ]}
            >
              {step.label}
            </Typography>
          </Box>
        </React.Fragment>
      );
    })}
  </Box>
);

Stepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string.isRequired }),
  ).isRequired,
};

export default Stepper;
